import { render, staticRenderFns } from "./BetfairLog.vue?vue&type=template&id=4fe55fcb&"
import script from "./BetfairLog.vue?vue&type=script&lang=js&"
export * from "./BetfairLog.vue?vue&type=script&lang=js&"
import style0 from "./BetfairLog.vue?vue&type=style&index=0&id=4fe55fcb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports